import { Helmet } from 'react-helmet';

export default function Head({ keywords }) {
  return <Helmet meta={[{ content: keywords, name: 'keywords' }]} />;
}
